export enum PatientSearchOptionWithBirthDate {
    address = 'address',
    identifierSocialSecurity = 'identifierSocialSecurity',
    insurance = 'insurance',
    other = 'other',
}
